const localizers = {
  'loading.msg': () => `Načítání...`,
  'SASServer.genericError.msg': () => `Server je nedosažitelný.`,
  'SASReport.genericError.msg': () => `Nelze načíst vybraný report.`,
  'SASReportImage.genericError.msg': () => `Obraz reportu se nepodařilo načíst.`,
  'SASReportImage.imageNotSupported.msg': () => `Obrazy nejsou pro tento typ obsahu reportu podporovány.`,
}
export default localizers;
